import { formatCount, formatSecondsToUTCtime } from "@memorang/helpers/common";
import { formatDate } from "@memorang/helpers/date";
import pluralize from "pluralize";
import type { UserSession, UserSessionsByType } from "../api/user-sessions";

type LegacyTestsCardData = {
	title: string;
	subtitle: string;
	list: {
		title: string;
		description: string;
		numericId: number;
		id: string;
	}[];
};

const flattenCompletedSessions = (
	sessionsByType: UserSessionsByType,
): UserSession[] =>
	Object.values(sessionsByType)
		.flat()
		.filter((session) => session.status === "COMPLETE")
		.toSorted(
			(a, b) =>
				new Date(b.startTime).getTime() - new Date(a.startTime).getTime(),
		);

export const getLegacyTestsCardsData = (
	sessionsByType: UserSessionsByType | undefined,
): LegacyTestsCardData | undefined => {
	if (!sessionsByType) {
		return undefined;
	}

	const sessions = flattenCompletedSessions(sessionsByType);
	if (sessions.length === 0) {
		return undefined;
	}

	return {
		title: "Legacy tests",
		subtitle: `Based on ${formatCount("completed assessment", sessions.length, true)}`,
		list: sessions.map((session) => ({
			id: String(session.numericId),
			numericId: session.numericId,
			title: `Test #${session.numericId} | ${formatDate(session.startTime)}`,
			description: `${session.numItems} ${pluralize("question", session.numItems)} • ${formatSecondsToUTCtime(session.timeTaken)}`,
		})),
	};
};
